export function subscript(num: number) {
  let result = "";
  while (num >= 10) {
    result = String.fromCharCode(0x2080 + (num % 10)) + result;
    num = Math.floor(num / 10);
  }
  return String.fromCharCode(0x2080 + num) + result;
}
